import { useMemo } from 'react';
import useAttachmentsModal from 'hooks/useAttachmentsModal';
import AttachmentModal from 'components/Attachments/AttachmentModal';
import { IconForwardBtn } from 'components/Icons';
import { renderDate } from 'lib';
import { useActiveReportStore } from 'hooks/useActiveReportStore';
import { HoneReportTypes } from '../../../constants';
import { useModalState } from './hooks/useModalState';
import { useReportsStore } from 'hooks/useReportsStore';

const NTAttachmentManager = () => {
  const currentReport = useActiveReportStore(state => state.currentReport);
  const selectedReport = useReportsStore(state => state.selectedReport);
  const { showAttachmentImage, attachmentsUrl, attachmentMetadata, isLoading, handleCloseAttachmentImage } =
    useAttachmentsModal();

  const { modalState, showModal } = useModalState();

  const breadcrumb = useMemo(() => {
    if (!modalState) return null;
    if (attachmentMetadata) {
      return (
        <ol className="breadcrumb">
          <li>{attachmentMetadata?.description}</li>
        </ol>
      );
    }
    return (
      <ol className="breadcrumb">
        {modalState.parent && (
          <>
            <li>{modalState.parent}</li>
            <li className="breadcrumb-separator">
              <IconForwardBtn />
            </li>
          </>
        )}
        <li>{modalState.title}</li>
        {modalState?.date && modalState?.date.end === '' ? (
          <>
            <li className="breadcrumb-separator">
              <IconForwardBtn />
            </li>
            <li>
              {modalState?.date.start}
              {selectedReport &&
                selectedReport.type !== HoneReportTypes.ApAging &&
                renderDate(selectedReport?.startDateText)}
            </li>
          </>
        ) : (
          <>
            <li className="breadcrumb-separator">
              <IconForwardBtn />
            </li>
            <li>{modalState?.date && renderDate(modalState?.date.end)}</li>
          </>
        )}
      </ol>
    );
  }, [modalState, attachmentMetadata]);

  const modalTitle = useMemo(() => {
    return attachmentMetadata ? modalState?.title : currentReport?.title;
  }, [modalState, attachmentMetadata]);

  return (
    <>
      {showModal && (
        <AttachmentModal
          showAttachmentImage={showAttachmentImage}
          handleClose={handleCloseAttachmentImage}
          attachmentMetadata={attachmentMetadata}
          attachmentsUrl={attachmentsUrl}
          title={modalTitle!}
          subtitle={[currentReport?.title, modalState.parent, modalState.title, modalState.date?.start]}
          breadcrumb={breadcrumb}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default NTAttachmentManager;
